import youtube from '../assets/images/tiredness.jpg'
import instagram from '../assets/images/instagram.jpg'
import tiktok from '../assets/images/tiktok.jpg'
import aiCoaching from '../assets/images/aicoaching.jpg'
import aiImplementation from '../assets/images/aiimplementation.jpg'
import mercury from '../assets/images/mercury.jpg'
import commerceSquad from '../assets/images/wistful.jpg'
import leagueAhead from '../assets/images/joy.jpg'
import ahaMoment from '../assets/images/serenity.jpg'

// Each inner array is one visual group, rendered top to bottom.
// `slogan` is my role, `name` is the thing, `description` is what it is.
// An entry without a `link` renders as plain text (used for exited companies).
// `showSloganOnMob` shows the slogan instead of the description on small screens.
export const linkGroups = [
    [
        {
            name: "Youtube",
            description: "content to help founders stay ahead of the curve",
            slogan: "Creator",
            img: youtube,
            link: "https://youtube.com/c/deeptalkstv",
        },
        {
            name: "Instagram",
            description: "@deep.or.nah · insider takes on AI",
            slogan: "Creator",
            img: instagram,
            link: "https://www.instagram.com/deep.or.nah/",
        },
        {
            name: "TikTok",
            description: "@deep.or.nah · quick takes on AI news",
            slogan: "Creator",
            img: tiktok,
            link: "https://www.tiktok.com/@deep.or.nah",
        },
    ],
    [
        {
            name: "AI Coaching for Execs",
            description: "private, 1-on-1, for getting ahead",
            slogan: "Coach",
            img: aiCoaching,
            link: "https://relibit.com/coaching",
        },
        {
            name: "Reliable Bits - Implement AI",
            description: "AI systems built for your business",
            slogan: "Co-Founder",
            img: aiImplementation,
            link: "https://relibit.com/integration",
        },
    ],
    [
        {
            name: "Mercury",
            description: "online business banking for startups",
            slogan: "Investor",
            showSloganOnMob: true,
            img: mercury,
            link: "https://mercury.com/",
        },
    ],
    [
        {
            name: "Commerce Squad",
            description: "subscription tech team for ecommerce",
            slogan: "Co-Founder (exited)",
            showSloganOnMob: true,
            img: commerceSquad,
        },
        {
            name: "League Ahead",
            description: "truly understand AI and ML",
            slogan: "Co-Founder (exited)",
            showSloganOnMob: true,
            img: leagueAhead,
        },
        {
            name: "Aha Moment",
            description: "ML model to glean statistical insights from your business sales data in natural language",
            slogan: "Investor (exited)",
            showSloganOnMob: true,
            img: ahaMoment,
        },
    ],
]
